export default "__VITE_ASSET__4b59066a__"